import { jsx as _jsx } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { HeartFillIcon, HeartIcon } from '@yonderland/andes-icons';
import { IconButton } from '@yonderland/andes-react';
import { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { wishListActions } from '../../redux/wishList/actions/WishListActions.creators';
import { makeIsProductInWishList } from '../../redux/wishList/selectors/WishListSelectors';
export const WishlistButtonAndes = ({ productCode, productId, colourId, skuId, buttonProps, onToggle, testId = 'add_to_wishlist', }) => {
    const { isShopLanding } = useAemConfig();
    const shouldAnimate = useRef(false);
    const dispatch = useDispatch();
    const inWishList = useSelector(makeIsProductInWishList(productCode, colourId));
    const mergedButtonProps = Object.assign(Object.assign({}, buttonProps), { icon: Object.assign({ source: inWishList ? HeartFillIcon : HeartIcon, animation: shouldAnimate.current ? 'pulse' : undefined }, ((buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.icon) || {})) });
    const handleWishListToggle = () => {
        shouldAnimate.current = !inWishList;
        dispatch(wishListActions.toggleProduct({
            colorId: colourId,
            productCode,
            productId,
            sku: skuId,
        }));
        onToggle === null || onToggle === void 0 ? void 0 : onToggle();
    };
    if (isShopLanding) {
        return null;
    }
    return (_jsx(IconButton, Object.assign({ testId: testId, size: "sm", theme: "neutral", variant: "plain", onClick: handleWishListToggle }, mergedButtonProps)));
};
